import { isNil } from 'lodash-es'
import type { ReactNode } from 'react'

const renderDashIfNil = (
  value: ReactNode,
  formattedValue?: ReactNode,
): ReactNode => {
  return isNil(value) ? '-' : (formattedValue ?? value)
}

export default renderDashIfNil
